module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/acc6c29b5eee67bc6b2aa85854d9bb3a.svg";